import { getExternalProgramProductLabel } from './external-program-codes';

// Refer to ProductTags in Venus
export enum ProductTag {
    Unknown = 0,
    PersonalLoan = 1,
    GreenLoan = 2,
    BusinessFinance = 3,
    CarLoan = 4,
    PointOfSale = 5,
    DeferredPaymentAgreement = 6,
    SwiftWorkingCapital = 7,
    LegalLoan = 8,
    SARenewableEnergy = 12,
    NSWRenewableEnergy = 13,
    RenewableBrokerLoan = 14,
    RenewableInterestFree = 15,
    CommercialCarLoan = 16
}

export const RenewableProductTags = [
    ProductTag.GreenLoan,
    ProductTag.RenewableBrokerLoan,
    ProductTag.SARenewableEnergy,
    ProductTag.NSWRenewableEnergy,
    ProductTag.RenewableInterestFree
];

export const NonQuoteRenewableProductTags = [ProductTag.GreenLoan, ProductTag.RenewableInterestFree];
export const InvoiceReferenceRenewableProductTags = [...NonQuoteRenewableProductTags];

// C.f. ProductTag enum
export const ProductTagDescriptions: Record<string, string> = {
    Unknown: 'Unknown',
    PersonalLoan: 'Personal loan',
    GreenLoan: 'Green loan',
    BusinessFinance: 'Business finance',
    CarLoan: 'Vehicle loan',
    PointOfSale: 'Point of sale',
    DeferredPaymentAgreement: 'Deferred payment agreement',
    SwiftWorkingCapital: 'Swift working capital',
    LegalLoan: 'Legal loan',
    SARenewableEnergy: 'SA Home Battery Scheme',
    NSWRenewableEnergy: 'NSW Empowering Homes Program',
    RenewableBrokerLoan: 'Renewable loan',
    RenewableInterestFree: 'Zero interest payment plan',
    CommercialCarLoan: 'Commercial car loan'
};

export function getProductTagDescription(productTag: ProductTag, externalProgram?: string): string {
    const externalLabel =
        productTag === ProductTag.RenewableInterestFree ? getExternalProgramProductLabel(externalProgram) : undefined;

    return externalLabel || ProductTagDescriptions[ProductTag[productTag]] || 'N/A';
}

export const ToExperience = (productTag: ProductTag): string => {
    switch (productTag) {
        case ProductTag.GreenLoan:
            return 'Green';
        case ProductTag.RenewableInterestFree:
            return 'RenewableInterestFree';
        case ProductTag.NSWRenewableEnergy:
            return 'NSWRenewableEnergy';
        case ProductTag.SARenewableEnergy:
            return 'SARenewableEnergy';
        case ProductTag.RenewableBrokerLoan:
            return 'RenewableBroker';
        default:
            return 'Unknown';
    }
};
